module.exports = __webpack_public_path__ + "static/media/Sector5.888470c6.jpg";